export default "__VITE_ASSET__DQoGktBA__"